import styles from './PopOutModal.module.css'
import { Dismiss20Filled } from '@fluentui/react-icons'

interface ModalProps {
    title?: string
    content: JSX.Element
    isOpen: boolean
    onClose: () => void
    bottomContent?: JSX.Element
    clickOff?: boolean
}

const PopOutModal: React.FC<ModalProps> = ({
    title,
    content,
    isOpen,
    onClose,
    bottomContent,
    clickOff = true,
}) => {
    if (!isOpen) return null

    return (
        <div
            className={styles.container}
            onClick={() => {
                if (clickOff) onClose()
            }}
        >
            <div
                className={styles.modalContainer}
                onClick={(e) => e.stopPropagation()}
            >
                <div className={styles.titleExitContainer}>
                    <h1 className={styles.title}>{title ? title : ''}</h1>
                    <button className={styles.closeButton} onClick={onClose}>
                        <Dismiss20Filled
                            style={{
                                display: 'block',
                                lineHeight: 1,
                            }}
                        />
                    </button>
                </div>

                <div className={styles.modalContent}>
                    {content}
                </div>
                <div className={styles.bottomContainer}>
                    {bottomContent ? bottomContent : ''}
                </div>
            </div>
        </div>
    )
}

export default PopOutModal
